import { alpha } from '@mui/material/styles';
import { IconButton, styled } from '../../../base';

export const ShareButton = styled(IconButton)(({ theme }) => ({
    width: 72,
    height: 72,
    marginInlineEnd: theme.spacing(1),
    backgroundColor: alpha(theme.palette.grey[600], 0.04),
    '&:hover': {
        backgroundColor: theme.palette.primary.light,
        '& svg': {
            color: theme.palette.primary.main,
        },
    },
}));
